import { motion } from 'framer-motion';
import React from 'react';
import { bezier1, bezier2 } from './../../services/framer-motion-service';

const FramerConditionalOpacityContainer = ({
   condition,
   delay = 0,
   duration = 0.25,
   children
}) => {
   return (
      <motion.div
         initial={{ opacity: 0 }}
         animate={{
            opacity: condition ? 1 : 0
         }}
         transition={{ duration, delay, easings: [bezier1, bezier2] }}
      >
         {children}
      </motion.div>
   );
};

export default FramerConditionalOpacityContainer;
